import { useEffect, useState } from "react";
import { navLinks, siteMeta } from "@/mocks/gossip";

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const linkColor = scrolled ? "text-foreground-700 hover:text-primary-600" : "text-background-50/90 hover:text-background-50";

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "border-b border-background-200 bg-background-50/95 backdrop-blur"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <nav className="shell flex h-16 items-center justify-between md:h-20" aria-label="主导航">
        <a href="#top" className="flex cursor-pointer items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg font-bold text-background-50">
            瓜
          </span>
          <span className="flex flex-col leading-none">
            <strong className={`font-heading text-lg tracking-wide ${scrolled ? "text-foreground-950" : "text-background-50"}`}>
              {siteMeta.name}
            </strong>
            <span className={`mt-0.5 text-[11px] ${scrolled ? "text-foreground-500" : "text-background-50/70"}`}>
              蹲点实时瓜
            </span>
          </span>
        </a>

        <ul className="hidden items-center gap-7 lg:flex">
          {navLinks.map((item) => (
            <li key={item.href}>
              <a href={item.href} className={`cursor-pointer text-sm font-medium transition-colors ${linkColor}`}>
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a href="#contact" className="btn-primary hidden md:inline-flex">
            <i className="ri-send-plane-line" aria-hidden="true" />
            我要爆料
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? "关闭导航菜单" : "打开导航菜单"}
            aria-expanded={menuOpen}
            className={`flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border text-xl transition-colors lg:hidden ${
              scrolled
                ? "border-background-300 text-foreground-800"
                : "border-background-50/40 text-background-50"
            }`}
          >
            <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} aria-hidden="true" />
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <ul className="shell flex flex-col py-3">
            {navLinks.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="block cursor-pointer border-b border-background-100 py-3 text-sm font-medium text-foreground-800 transition-colors hover:text-primary-600"
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li className="pt-4">
              <a href="#contact" onClick={() => setMenuOpen(false)} className="btn-primary w-full">
                <i className="ri-send-plane-line" aria-hidden="true" />
                我要爆料
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}